import React from 'react'
import { t } from 'ttag'
import { connect } from 'react-redux'

import { updatePageTitle } from '../../actions/pageInfo'
import { browserHistory } from '../../Routes'

class MilitarySearch extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      term: ''
    }
  }

  componentDidMount() {
    this.props.dispatch(updatePageTitle(t`Military Occupation Search`))
  }

  render() {
    return (
      <div className="container">
        <div>
          <div className="row">
            <div className="col-xs-10">
              <h2>{t`Are you coming from the military? If so, we can help.`}</h2>
            </div>
            <div className="col-xs-2">
              <img
                src="/images/headed2/new/clusters/svg/Headed2-ClusterIcons_Military.svg"
                className="img-responsive"
              />
            </div>
          </div>

          <div className="jumbotron with-dotted-border" style={{ marginTop: '20px' }}>
            <form
              onSubmit={e => {
                e.preventDefault()
                browserHistory.push(`/search/military?q=${this.state.term}`)
              }}>
              <p>{t`Begin by entering the military title or code you held in the box below:`}</p>
              <div className="input-group">
                <label htmlFor="jstitle" className="sr-only">
                  {t`Enter a Job Title:`}
                  <br />
                </label>
                <input
                  type="text"
                  name="q"
                  id="q"
                  className="form-control input-lg"
                  onChange={v => {
                    //console.log(term);
                    this.setState({
                      ...this.state,
                      term: v.target.value
                    })
                  }}
                  placeholder={t`Enter a job title`}
                />
                <span className="input-group-btn">
                  <button type="submit" className="btn btn-submit input-lg">
                    {t`Search`}
                  </button>
                </span>
              </div>
            </form>
          </div>
        </div>

        <br className="clear" />
      </div>
    )
  }
}

export default connect(null, dispatch => ({ dispatch }))(MilitarySearch)
